import React, { PureComponent, PropTypes } from 'react';
import Separated from '../common/components/Separated';
import ShortUserName from './ShortUserName';
import _ from 'underscore';

export default class UserList extends PureComponent {
  static propTypes = {
    users: PropTypes.array.isRequired,
    component: PropTypes.func
  };

  static defaultProps = {
    component: ShortUserName
  };

  render() {
    const { className, component: Comp, users } = this.props;

    return (
      <Separated className={className}>
        {
          _.compact(users)
            .map((user, i) => <Comp key={i} user={user}/>)
        }
      </Separated>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/UserList.jsx